export default "__VITE_ASSET__Ceb4YSPQ__"